import React, { FC } from "react"
import CardStates, { CardState } from "utils/CardStates"
import { CarrotCardEligibleModule } from "components/views/molecules/carrotcardmodules/CarrotCardEligibleModule"
import { CarrotCardLockedModule } from "components/views/molecules/carrotcardmodules/CarrotCardLockedModule"
import { CarrotCardShippedModule } from "components/views/molecules/carrotcardmodules/CarrotCardShippedModule"
import { CarrotCardActiveModule } from "components/views/molecules/carrotcardmodules/CarrotCardActiveModule"
import { useSelector } from "react-redux"
import { getCardState, getIsUsa } from "reducers/userInfo"
import { getCarrotLite } from "reducers/companyInfo"
import { getNeedsBenefitEnrollment } from "derivedSelectors"
import { getHasDeductibleRemaining } from "derivedSelectors/deductibleSelectors"

const carrotCardModules: Partial<Record<CardState, FC<CarrotCardModuleProps>>> = {
  [CardStates.LOCKED]: CarrotCardLockedModule,
  [CardStates.ACTIVE]: CarrotCardActiveModule,
  [CardStates.SHIPPED]: CarrotCardShippedModule,
  [CardStates.ELIGIBLE]: CarrotCardEligibleModule
}

type CarrotCardModuleContainerProps = {
  backgroundColor: string
  onlyShowRequestModule?: boolean
}

export type CarrotCardModuleProps = {
  backgroundColor: string
  isVirtualCard: boolean
}

/**
 * A connected factory component that returns the module for a given card state
 *
 * This component returns null if no view corresponds to the given cardState
 * or the member is part of a carrot lite company
 */
export const CarrotCardModuleContainer: FC<CarrotCardModuleContainerProps> = ({
  backgroundColor,
  onlyShowRequestModule = true
}: CarrotCardModuleContainerProps) => {
  const cardState = useSelector(getCardState) as CardState
  const carrotLite = useSelector(getCarrotLite)
  const isUsa = useSelector(getIsUsa)
  const hasDeductibleRemaining = useSelector(getHasDeductibleRemaining)
  const needsBenefitEnrollment = useSelector(getNeedsBenefitEnrollment)

  if (carrotLite) {
    return null
  }

  if (
    (cardState === CardStates.ACTIVE || cardState === CardStates.LOCKED || cardState === CardStates.SHIPPED) &&
    onlyShowRequestModule
  ) {
    return null
  }

  if (needsBenefitEnrollment || hasDeductibleRemaining) {
    return null
  }

  const ModuleComponent = carrotCardModules[cardState]

  return ModuleComponent ? <ModuleComponent isVirtualCard={!isUsa} backgroundColor={backgroundColor} /> : null
}
